export function extractBase64Images(content: string): string[] {
  const base64Regex = /<img.*?src="(data:image\/[^;]+;base64[^"]+)".*?>/g
  const base64Images: string[] = []

  let match: RegExpExecArray | null = base64Regex.exec(content)
  while (match !== null) {
    base64Images.push(match[1])
    match = base64Regex.exec(content)
  }

  return base64Images
}

export function base64ToFile(dataURI: string, fileName: string): File {
  const byteString = atob(dataURI.split(',')[1])
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
  const arrayBuffer = new ArrayBuffer(byteString.length)
  const uint8Array = new Uint8Array(arrayBuffer)

  for (let i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i)
  }

  return new File([uint8Array], fileName, { type: mimeString })
}
